module.exports = __webpack_public_path__ + "static/media/girl_with_label.41baaa24.png";